import { render, staticRenderFns } from "./TrainingCenterPage.vue?vue&type=template&id=b4a3f046&scoped=true&"
import script from "./TrainingCenterPage.vue?vue&type=script&lang=js&"
export * from "./TrainingCenterPage.vue?vue&type=script&lang=js&"
import style0 from "./TrainingCenterPage.vue?vue&type=style&index=0&id=b4a3f046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a3f046",
  null
  
)

export default component.exports